import React from "react";
import { Col, Row } from "antd";
import style from "../../index.module.scss";
import Form from "rc-field-form";
import JudgeOptions from "../JudgeOptions";

export default function FieldJudgeOptions() {
    const initialJudge = [
        { key: "1", description: "正确", isRight: true },
        { key: "0", description: "错误", isRight: false }
    ];

    return (
        <Row gutter={[0, 20]}>
            <Col span={4} className={style.label}>
                选项
            </Col>

            <Col span={18} offset={1}>
                <Form.Field name="judgeOptions" initialValue={initialJudge}>
                    <JudgeOptions />
                </Form.Field>
            </Col>
        </Row>
    );
}
